import React from "react";

export default function AnimatedSvgGroup({
  timings,
  progress,
  children,
  maxOpacity = 1,
  ...props
}) {
  // const totalDuration = timings.duration;

  const fadeProgress = 1;
  // if (progress >= totalDuration) {
  //   fadeProgress = 1;
  // } else {
  //   fadeProgress = progress / totalDuration;
  // }

  const allProps = {
    ...props,
    opacity: fadeProgress,
  };

  return <g {...allProps}>{children}</g>;
}
